var _g, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1837_20720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9419 6.15632L23.4422 7.65606C23.3427 7.75549 23.2869 7.89037 23.2869 8.03096V10.5626L25.847 7.23157V6.53122C25.847 6.05891 25.2759 5.82237 24.9419 6.15632Z",
    fill: "#AD4F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4688 8.15308H26.7685L23.4375 10.7132H25.9691C26.1097 10.7132 26.2446 10.6573 26.344 10.5579L27.8437 9.05817C28.1777 8.72417 27.9411 8.15308 27.4688 8.15308Z",
    fill: "#AD4F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2516 28C10.5989 28 6 23.4012 6 17.7484C6 12.0956 10.5989 7.49683 16.2516 7.49683C21.9044 7.49683 26.5032 12.0957 26.5032 17.7484C26.5032 23.4012 21.9043 28 16.2516 28Z",
    fill: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2515 25.828C11.7964 25.828 8.17188 22.2035 8.17188 17.7484C8.17188 13.2932 11.7963 9.6687 16.2515 9.6687C20.7067 9.6687 24.3311 13.2932 24.3311 17.7483C24.3311 22.2035 20.7066 25.828 16.2515 25.828Z",
    fill: "#506366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2517 23.6562C12.9942 23.6562 10.344 21.006 10.344 17.7485C10.344 14.491 12.9942 11.8408 16.2517 11.8408C19.5092 11.8408 22.1594 14.491 22.1594 17.7485C22.1594 21.006 19.5091 23.6562 16.2517 23.6562Z",
    fill: "#6EE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2516 21.4842C14.1917 21.4842 12.5159 19.8083 12.5159 17.7484C12.5159 15.6886 14.1917 14.0127 16.2516 14.0127C18.3115 14.0127 19.9874 15.6886 19.9874 17.7484C19.9874 19.8084 18.3115 21.4842 16.2516 21.4842Z",
    fill: "#FD6F71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2514 19.3124C17.1151 19.3124 17.8153 18.6122 17.8153 17.7485C17.8153 16.8847 17.1151 16.1846 16.2514 16.1846C15.3877 16.1846 14.6875 16.8847 14.6875 17.7485C14.6875 18.6122 15.3877 19.3124 16.2514 19.3124Z",
    fill: "#FADC60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2516 16.827C15.9972 17.0815 15.9972 17.4941 16.2516 17.7485C16.506 18.0029 16.9187 18.0029 17.1731 17.7485L26.7684 8.15315L25.847 7.23169L16.2516 16.827Z",
    fill: "#C86D5C"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    stroke: "#BABDCC",
    strokeDasharray: "2 2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1837_20720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step-4.dcd00fb67d95ecbfe25d19fd5f8c9965.svg";
export { ForwardRef as ReactComponent };